import { combineReducers } from 'redux'

import { reducer as usersListReducer } from './DataAccess'

export default combineReducers({
  list: usersListReducer
})
